import jwtDecode from "jwt-decode";

export const decodeJWTToken = (token: string) => {
    if (token) {
        const decoded = jwtDecode(token);
        return decoded;
    }
    return null;
};
